import React from "react";
import Slider from "react-slick";

function Popular() {
  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true,

    responsive: [
      {
        breakpoint: 1600,
        settings: {
          centerMode: false,
          slidesToShow: 3,
        },
      },
      // {
      //   breakpoint: 1400,
      //   settings: {
      //     centerMode: false,
      //     slidesToShow: 3.2,
      //   },
      // },
      {
        breakpoint: 1200,
        settings: {
          centerMode: false,
          slidesToShow: 2.8,
        },
      },
      {
        breakpoint: 844,
        settings: {
          centerMode: false,
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 700,
        settings: {
          centerMode: false,
          slidesToShow: 1.45,
        },
      },
      {
        breakpoint: 526,
        settings: {
          centerMode: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 450,
        settings: {
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="pt120 pb-3">
      <div>
        <div className="d-flex justify-content-between align-items-center pb-4">
          <h3>popular categories</h3>
          <div>
            <button className="allbutton">See all</button>
          </div>
        </div>
        {/* <div className="popularCategories"> */}
        {/* <Slider {...settings}>
          <div className="popularCards">
            <div className="firstCard pt-2">
              <div>
                <img src="image 32 (1).png" alt="first" />
              </div>
              <div>
                <img src="image 32 (3).png" alt="first" />
              </div>
              <div>
                <img src="image 32.png" alt="first" />
              </div>
             
            </div>
            <p>pfp</p>
          </div>
          <div className="popularCards">
            <div className="secondCard">
              <div>
                <img src="image 57.png" alt="first" />
              </div>
              <div>
                <img src="image 32 (2).png" alt="first" />
              </div>
              <div>
                <img src="image 56.png" alt="first" />
              </div>
            </div>
            <p>Art</p>
          </div>
          <div className="popularCards">
            <div className="thirdCard">
              <div>
                <img src="green.png" alt="first" />
              </div>
              <div>
                <img src="red.png" alt="first" />
              </div>
              <div>
                <img src="image 32 (5).png" alt="first" />
              </div>
            </div>
            <p>metaverse</p>
          </div>
          <div className="popularCards">
            <div className="secondCard">
              <div>
                <img src="image 57 (1).png" alt="first" />
              </div>
              <div>
                <img src="game.png" alt="first" />
              </div>
              <div>
                <img src="image 56 (1).png" alt="first" />
              </div>
            </div>
            <p>Art</p>
          </div>
          <div className="popularCards">
            <div className="firstCard pt-2">
              <div>
                <img src="image 32 (1).png" alt="first" />
              </div>
              <div>
                <img src="image 32 (3).png" alt="first" />
              </div>
              <div>
                <img src="image 32.png" alt="first" />
              </div>
            </div>
            <p>pfp</p>
          </div>
        </Slider> */}

        <Slider {...settings}>
          <div className="popularCards">
            <div className="cardsImg">
              <img src="Group 33210.png" alt="group" />
            </div>
            <p>pfp</p>
          </div>
          <div className="popularCards">
            <div className="cardsImg">
              <img src="Group 33209.png" alt="group" />
            </div>
            <p>Art</p>
          </div>
          <div className="popularCards">
            <div className="cardsImg">
              <img src="Group 33211.png" alt="group" />
            </div>
            <p>metaverse</p>
          </div>
          <div className="popularCards">
            <div className="cardsImg">
              <img src="Group 33212.png" alt="group" />
            </div>
            <p>domains</p>
          </div>
          <div className="popularCards">
            <div className="cardsImg">
              <img src="Group 33209.png" alt="group" />
            </div>
            <p>Art</p>
          </div>
        </Slider>
        {/* </div> */}
      </div>
    </div>
  );
}

export default Popular;
